import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import { tableService } from "../services/tableService";
import { PartnerType } from "../utils/partners.enum";
import { Table } from "../entities/Table";

export const useAllPartnerTables = () => {
  const partnerTypes = Object.values(PartnerType);

  const results = useQueries({
    queries: partnerTypes.map((type) => ({
      queryKey: ["allTables", { type, limit: 99 }],
      queryFn: () => tableService.table({ type, limit: 99 }),
    })),
  });

  const isLoading = results.some((result) => result.isLoading);

  const tables = useMemo(() => {
    const byId = new Map<string, Table>();

    results.forEach((result) => {
      result.data?.tables?.forEach((table) => {
        const id = table?._id?.toString();
        if (!id || table.isActive === false || byId.has(id)) return;
        byId.set(id, table);
      });
    });

    return [...byId.values()];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [results.map((result) => result.dataUpdatedAt).join("|")]);

  const getTable = (tableId?: string) =>
    tableId
      ? tables.find((table) => table._id?.toString() === tableId.toString())
      : undefined;

  const getTablesByPartner = (partner: PartnerType | string) =>
    tables.filter(
      (table) => table.type?.toUpperCase() === String(partner).toUpperCase(),
    );

  return { tables, isLoading, getTable, getTablesByPartner };
};
